// extracted by mini-css-extract-plugin
module.exports = {"splitpane":"ResizableSplitPane_splitpane__2q_bU","dividerWrapper":"ResizableSplitPane_dividerWrapper__1RqcZ","divider":"ResizableSplitPane_divider__P1YTM"};